"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("quill/dist/quill.core.css");
require("quill/dist/quill.snow.css");
require("quill/dist/quill.bubble.css");
require("./quill.css");
var vue_quill_editor_1 = require("vue-quill-editor");
var vue_1 = require("@formily/vue");
var composition_api_1 = require("@vue/composition-api");
var element_ui_1 = require("element-ui");
var quill_1 = __importDefault(require("quill"));
var axios_1 = __importDefault(require("axios"));
// 让编辑器支持A标签
var Link = quill_1.default.import('formats/link');
var FileBlot = /** @class */ (function (_super) {
    __extends(FileBlot, _super);
    function FileBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileBlot.create = function (value) {
        var node;
        if (value && !value.href) {
            node = _super.create.call(this, value);
        }
        else {
            node = _super.create.call(this, value.href);
            node.innerText = value.innerText;
            node.download = value.innerText;
        }
        return node;
    };
    return FileBlot;
}(Link));
// @ts-ignore
FileBlot.blotName = 'link';
// @ts-ignore
FileBlot.tagName = 'A';
quill_1.default.register(FileBlot);
// 上传函数
var uploadFn = function (quill, file) {
    var formData = new FormData();
    formData.append('file', file);
    axios_1.default
        .post('/relay/cosfile', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
        .then(function (response) {
        var url = response.data.FileList[0].url;
        var range = quill.getSelection();
        if (range) {
            quill.insertEmbed(range.index, 'image', url);
            quill.setSelection(range.index + 1);
        }
    });
};
// 富文本编辑器实例
var quill = null;
// 上传成功处理
var uploadSuccess = function (type, val) {
    var _a = val.FileList[0], url = _a.url, name = _a.name;
    // @ts-ignore
    var range = quill.getSelection();
    if (range) {
        if (type == 'image') {
            // @ts-ignore
            quill.insertEmbed(range.index, 'image', url);
        }
        else if (type == 'file') {
            // @ts-ignore
            quill.insertEmbed(range.index, 'link', { href: url, innerText: name });
        }
        // @ts-ignore
        quill.setSelection(range.index + 1);
    }
};
// 编辑器工具栏选项
var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    // ['blockquote', 'code-block'],
    // [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    // [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    // [{ direction: 'rtl' }],
    [{ size: ['small', false, 'large', 'huge'] }],
    // [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }],
    // // [{ font: [] }],
    // [{ align: [] }],
];
// 编辑器选项
var editorOption = {
    // 覆盖 quill 默认的 "Insert text here ..."
    placeholder: '请输入',
    modules: {
        toolbar: {
            container: toolbarOptions,
            handlers: {
                upload: function () { },
            },
        },
    },
};
var quillEditorWrapper = (0, composition_api_1.defineComponent)({
    name: 'quillEditor3',
    props: ['disabled'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, listeners = _a.listeners, emit = _a.emit;
        return function () {
            var field = (0, vue_1.useField)();
            field.value.decoratorType = field.value.title ? 'FormItem' : null;
            var props = __assign(__assign(__assign({}, attrs), curProps), { 
                // 允许外层通过 x-component-props.placeholder 覆盖默认的 "请输入"
                options: __assign(__assign({}, editorOption), { placeholder: attrs.placeholder || editorOption.placeholder }) });
            return (0, vue_1.h)('div', {}, {
                default: function () { return [
                    (0, vue_1.h)(element_ui_1.Upload, {
                        attrs: {
                            action: '/relay/cosfile',
                            'on-success': function (val) {
                                uploadSuccess('image', val);
                            },
                        },
                        style: {
                            display: 'none',
                        },
                        ref: 'img',
                    }, {}),
                    (0, vue_1.h)(element_ui_1.Upload, {
                        attrs: {
                            action: '/relay/cosfile',
                            'on-success': function (val) {
                                uploadSuccess('file', val);
                            },
                        },
                        style: {
                            display: 'none',
                        },
                        ref: 'file',
                    }, {}),
                    (0, vue_1.h)(vue_quill_editor_1.quillEditor, {
                        ref: 'richEditor',
                        attrs: props,
                        on: __assign(__assign({}, listeners), { change: function (val) {
                                emit('change', val.html);
                            }, ready: function (quill) {
                                // 截屏图片粘贴
                                quill.root.addEventListener('paste', function (evt) {
                                    if (evt.clipboardData &&
                                        evt.clipboardData.files &&
                                        evt.clipboardData.files.length > 0) {
                                        evt.preventDefault();
                                        [].forEach.call(evt.clipboardData.files, function (file) {
                                            uploadFn(quill, file);
                                        });
                                    }
                                }, false);
                            } }),
                    }, {}),
                ]; },
            });
        };
    },
    mounted: function () {
        var _this = this;
        // @ts-ignore
        quill = this.$refs.richEditor.quill;
        // @ts-ignore
        var toolbar = quill.getModule('toolbar');
        toolbar.addHandler('image', function () {
            // @ts-ignore
            _this.$refs.img.$el.querySelector('.el-upload__input').click();
        });
        toolbar.addHandler('upload', function () {
            // @ts-ignore
            _this.$refs.file.$el.querySelector('.el-upload__input').click();
        });
    },
});
exports.default = quillEditorWrapper;
